// extracted by mini-css-extract-plugin
module.exports = {"root":"Sidebar_root__1yCx6","logo":"Sidebar_logo__19OZ3","nav":"Sidebar_nav__18KQo"};